/**
 * School View session cache (v3.78.0) — deliberately dependency-free so
 * App.js can clear it on sign-out without pulling the School View derivation
 * (and the PA-D tier data it imports) into the main bundle. Writers:
 * schoolViewData.js / classReportData.js through cachedPromise; the Student
 * Report evicts its own entry (evictCache, v3.98.0).
 */
const cache = new Map();

/** Sign-out / Retry hook. */
export function clearSchoolViewCache() {
  cache.clear();
}

/** Memoize the in-flight promise for a key; a rejected load is evicted so Retry refetches. */
export function cachedPromise(key, loader) {
  if (!cache.has(key)) {
    // A rejected load is evicted so Retry refetches — only if it is still the
    // entry (an evicted, replaced promise must not remove its replacement).
    const pending = loader().catch((err) => { if (cache.get(key) === pending) cache.delete(key); throw err; });
    cache.set(key, pending);
  }
  return cache.get(key);
}

/** Drop one entry (v3.98.0: the Student Report's fresh read evicts only its own key). */
export function evictCache(key) {
  cache.delete(key);
}

export function peekCache(key) {
  return cache.get(key);
}
